export default {
  OK: "OK",
  CLOSE: "アカウントが閉鎖されました！",
  BLOCK: "アカウントがブロックされました！",
  FREEZE: "アカウントが凍結されました！",
  SUSPEND: "アカウントが表示専用に変更されました。",
  passwordRequired: "パスワードが必要です！",
  usernameRequired: "ユーザー名が必要です！",
  incompletedRequest: "何か問題が発生しました...",

  session_not_exists: "セッションが期限切れです！続行するには再度ログインしてください...",
  session_expired: "セッションが期限切れです！続行するには再度ログインしてください...",
  invalidSession: "セッションが期限切れです！続行するには再度ログインしてください...",
  accountIdRequired: "セッションが期限切れです！続行するには再度ログインしてください...",
  NoUserAccessRight: "許可が拒否されました！続行するには上位者に連絡してください...",
  account_not_exists: "無効なパスワードです。",
  invalid_password: "無効なパスワードです。",
  secondary_account_exists: "ニックネームはすでに作成されています。",
  systemError: "内部システムエラー。",
  new_login_id_exists: "無効なニックネームです。別のニックネームを設定してください。",
  loginLimit: "ログインの頻度が高すぎます。1分後に再試行してください...",
  requestLimit: "リクエストの頻度が高すぎます。",
  unableToGetBalanceAtTheMoment: "内部サーバーエラー。",
  oddsDisplayInvalid: "オッズが更新中です...",
  oddsIsUpdating: "オッズが更新中です...",
  atLeastTwoMatchToBetParlay: "パーレイベットには最低2つの試合を選択してください。",
  atLeastThreeMatchToBetParlay: "パーレイベットには最低3つの試合を選択してください。",
  duplicate_debit_record: "オッズが更新中です...",

  insufficient_balance: "残高が不足しています",
  betOverMaxPerMatch: "賭け金が最大賭け金を超えています。",
  betOverMax: "賭け金が最大賭け金を超えています。",
  betOverMaxBet: "賭け金が最大賭け金を超えています。",
  betLowerMin: "賭け金が最低賭け金を下回っています。",

  loginFailed: "ログインに失敗しました。後でもう一度お試しください...",
  requestFailed: "接続が不安定です。接続を確認してもう一度お試しください。",
  requestPending: "リクエスト保留中...",

  close: "アカウントが閉鎖されています！続行するには上位者に連絡してください...",
  suspend: "アカウントが停止されています！続行するには上位者に連絡してください...",
  freeze: "アカウントが凍結されています！続行するには上位者に連絡してください...",

  alphaNumOnly: "英数字のみ",

  // vuelidate
  isRequired: "{fname}を入力してください。",
  isMinValue: "{fname}は最低{fvalue}である必要があります。",
  isMaxValue: "{fname}は最大{fvalue}以下である必要があります。",
  isMinLength: "{fname}は少なくとも{fvalue}文字以上である必要があります。",
  isMaxLength: "{fname}は最大{fvalue}文字以下である必要があります。",
  isAlpha: "{fname}はアルファベットのみ許可されます。",
  isAlphaNum: "{fname}は英数字のみ許可されます。",
  isNumeric: "{fname}は数値のみ許可されます。",
  isEmail: "{fname}は有効なメールアドレスのみ許可されます。",
  isIpAddress: "{fname}は有効なIPv4アドレスのみ許可されます。",
  isSameAs: "{fname}は{fname2}と同じである必要があります。",
  isUrl: "{fname}はURLのみ許可されます。",
  containAlphaNum: "{fname}には少なくとも1つのアルファベットと1つの数字が必要です。",
  selectOption: "{fname}を選択してください。",
  notSameAs: "{fname}と{fname2}は同じにすることはできません。",

  currPasswordRequired: "現在のパスワードが必要です！",
  newPasswordRequired: "新しいパスワードが必要です！",
  confirmNewPasswordRequired: "新しいパスワードの確認が必要です！",
  passwordsNotMatch: "パスワードが一致しません！",
  nickNameRequired: "ニックネームが必要です！",

  startDateRequired: "開始日が必要です！",
  endDateRequired: "終了日が必要です！",
  pageSizeRequired: "ページサイズが必要です！",
  pageNumberRequired: "ページ番号が必要です！",
  sportsTypeRequired: "スポーツタイプが必要です！",

  workingDateRequired: "作業日が必要です！",
  leagueIdRequired: "リーグIDが必要です！",
  isOutrightRequired: "直撃が必要です！",

  maxParlayTicket: "パーレイの最大チケット数に達しました！",
  matchHide: "このマーケットは利用できません。他のマーケットをお試しください。",
  matchNotAllowBet: "このマーケットは利用できません。他のマーケットをお試しください。",
  matchNotActive: "この試合は利用できません。他の試合のマーケットをお試しください。",
  invalidBets: "このマーケットは利用できません。他のマーケットをお試しください。",

  invalidOddsBall: "オッズが更新中です...",
  selectLeague: "少なくとも1つのリーグを選択してください。",
  liveCasinoDisabled: "ライブカジノが無効です",
  lotteryDisabled: "宝くじが無効です",
  slotDisabled: "スロットが無効です",
  MiniGameDisabled: "ミニゲームが無効です",
  EsportsDisabled: "E-スポーツゲームが無効です",
  betTypeRequired: "ベットタイプが必要です。",
  betAmountRequired: "ベット金額が必要です。",
  invalidBetAmount: "無効なベット金額です。",
  currencyNotSupported: "サポートされていない通貨です",
  game_maintenance: "ゲームはメンテナンス中です。",
  forbiddenAccess: "アクセス禁止",
  invalidCurrency: "ベットに無効な通貨です。",
  connectionFailed: "ウォレットシステムのリンクに失敗しました。",

  //tournament
  login_id_not_exists: "無効なログインです。再度ログインを試してください。",
  noMatchSelected: "少なくとも1つの試合を選択してください。",
  invalidRoomRate: "無効なルームレートです。",
  invalidRoomLimit: "無効なルーム制限です。",
  invalidRoomPassword: "無効なPINコードです。PINコードは6桁の数字である必要があります。",
  invalidPassword: "無効なパスワードです",
  roomPasswordRequired: "PINコードが必要です。",
  minMatch: "最低3つの試合を選択してください。",
  maxMatch: "最大{max}試合が選択されました！",
  roomIdRequired: "ルームIDが必要です。",
  roomTypeRequired: "ルームタイプが必要です。",
  sessionTokenRequired: "セッショントークンが必要です。",
  matchDateRequired: "試合日が必要です。",
  matchRequired: "試合が必要です。",
  roomLimitRequired: "ルーム制限が必要です。",
  roomRateRequired: "ルームレートが必要です。",
  minRoomRate: "エントリーフィーは10以上である必要があります。",
  maxRoomRate: "エントリーフィーは1000以下である必要があります。",
  minRoomLimit: "プレイヤー数は3以上である必要があります。",
  maxRoomLimit: "プレイヤー数は30以下である必要があります。",
  invalidRoomType: "無効なルームタイプです。",
  invalidMatch: "無効な試合です。",
  dataError: "データエラー",
  MemberExists: "メンバーはすでに存在します。",
  invalidMember: "無効なメンバーです。",
  invalidleague: "無効なリーグです。",
  "createRoomFailed-1": "ルーム作成に失敗しました 1。",
  "createRoomFailed-2": "ルーム作成に失敗しました 2。",
  "createRoomFailed-3": "ルーム作成に失敗しました 3。",
  invalidOperator: "無効なオペレーターです。",
  roomFull: "ルームはすでに満員です。",
  memberExists: "メンバーはすでに存在します。",
  "joinFailed-1": "ルーム参加に失敗しました 1。",
  "joinFailed-2": "ルーム参加に失敗しました 2。",
  IPJoinedBefore: "このIPは以前に参加しています。",
  memberJoinedBefore: "以前に参加したことがあります。無料のパブリックルームには1回しか参加できませんのでご注意ください。",
  roomNotExists: "ルームが存在しません。",
  roomIsPublicFree: "ルームは無料公開されています。",
  roomEndedOrCancelled: "ルームは終了またはキャンセルされました。",
  roomEnded: "ルームはすでに終了しています。",

  matchLowerMin: "試合の最低額エラーが発生しました。",
  matchOverMax: "試合の最大額エラーが発生しました。",
  pointsOverLimit: "ポイントが上限を超えています。",
  roomOverMax: "ルームが上限を超えています。",
  invalidRoom: "無効なルームです。",
  roomLimitOverMax: "ルーム制限が上限を超えています。",
  rateLowerMin: "レートが最低額を下回っています。",
  rateOverMax: "レートが上限を超えています。",

  liveMatchNotAllowed: "ライブマッチは許可されていません。",
  roomLimitLowerMin: "ルーム制限が最低額を下回っています。",
  roomClosed: "ルームが閉鎖されています。",
  tournamentLeagueExists: "トーナメントリーグが存在します。",
  roomExists: "1つ以上のプライベートルームを作成することは許可されていません。",
  RoomExists: "1つ以上のプライベートルームを作成することは許可されていません。",
  betExists: "ベットはすでに存在します。",
  roomClosedNotAllowed: "ルームの閉鎖は許可されていません。",
  tournamentMatchExists: "トーナメントマッチが存在します。",
  account_id_required: "アカウントIDが必要です。",
  agent_comm_rate_required: "エージェント手数料率が必要です。",
  agent_id_required: "エージェントIDが必要です。",
  bet_amount_required: "ベット金額が必要です。",
  bet_id_required: "ベットIDが必要です。",
  credit_amount_required: "クレジット金額が必要です。",
  currency_required: "通貨が必要です。",
  debit_amount_required: "デビット金額が必要です。",
  duplicate_credit_record: "重複したクレジットレコード。",
  master_comm_rate_required: "マスター手数料率が必要です。",
  master_id_required: "マスターIDが必要です。",
  member_id_required: "メンバーIDが必要です。",
  member_wallet_not_exists: "メンバーウォレットが存在しません。",
  permission_denied: "許可が拒否されました。",
  rate_required: "レートが必要です。",
  result_exists: "結果はすでに存在します。",
  room_id_required: "ルームIDが必要です。",
  s_senior_comm_rate_required: "スーパースシニア手数料率が必要です。",
  s_senior_id_required: "スーパースシニアIDが必要です。",
  senior_comm_rate_required: "シニア手数料率が必要です。",
  senior_id_required: "シニアIDが必要です。",
  shareholder_comm_rate_required: "株主手数料率が必要です。",
  shareholder_id_required: "株主IDが必要です。",
  transfer_id_required: "振替IDが必要です。",
  minBetAmount: "最低ベット金額エラーが発生しました。",
  tournamentDisabled: "トーナメントは無効です。上位者に確認してください。",
  // tournamentDisabled: "Tournament coming soon. Please stay tune!!",
  marketTypeRequired: "マーケットタイプが必要です。",
  invalidMarketType: "無効なマーケットタイプが提供されました。",
  marketTypeChanged: "マーケットタイプの変更によりベットスリップが削除されました。<br />マーケットから再度選択してください。",
  changeStakeMin: "最小額の変更により、賭け金額が変更されました。",
  changeStakeMax: "最大額の変更により、賭け金額が変更されました。",
  betNotExists: "トーナメントに参加するには有効なベットをしてください。",
};


// export default {
//   OK: "OK",
//   CLOSE: "Account has been closed!",
//   passwordRequired: "Password is required!",
//   usernameRequired: "Username is required!",

//   session_not_exists: "Session expired! Please login again to continue...",
//   session_expired: "Session expired! Please login again to continue...",
//   invalidSession: "Session expired! Please login again to continue...",
//   accountIdRequired: "Session expired! Please login again to continue...",
//   NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
//   account_not_exists: "Invalid password.",
//   invalid_password: "Invalid password.",
//   secondary_account_exists: "Your nickname already created.",
//   systemError: "Internal System Error.",
//   new_login_id_exists: "Invalid nickname, please try to set different nickname.",
//   loginLimit: "You have login too frequent, please try again after 1 minute...",
//   requestLimit: "You have request too frequent.",
//   unableToGetBalanceAtTheMoment: "Internal Server Error.",
//   oddsDisplayInvalid: "Invalid Odds Display.",
//   oddsIsUpdating: "Odds Is Updating...",
//   atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",

//   insufficient_balance: "Insufficient Balance",
//   betOverMaxPerMatch: "Your stake exceeds the max stake.",
//   betOverMax: "Your stake exceeds the max stake.",
//   betLowerMin: "Your stake less than the min stake.",


//   loginFailed: "Login failed, please try again later...",
//   requestFailed: "Request failed, please check your internet connection.",

//   close: "Account is closed! Please contact your upline to continue...",
//   suspend: "Account is suspend! Please contact your upline to continue...",
//   freeze: "Account is freeze! Please contact your upline to continue...",

//   alphaNumOnly: "Alphanumeric only",

//   // vuelidate
//   isRequired: "Please enter a {fname}.",
//   isMinValue: "{fname} must have minimal of {fvalue}.",
//   isMaxValue: "{fname} must be less than or equal to {fvalue}.",
//   isMinLength: "{fname} must have at least {fvalue} characters.",
//   isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
//   isAlpha: "{fname} accept only alphabet.",
//   isAlphaNum: "{fname} accept only alphanumerics.",
//   isNumeric: "{fname} accept only numerics.",
//   isEmail: "{fname} accept only valid email addresses.",
//   isIpAddress: "{fname} accept only valid IPv4 addresses.",
//   isSameAs: "{fname} must be same as {fname2}.",
//   isUrl: "{fname} accept only URLs.",
//   containAlphaNum: "{fname} must have at least one alphabet and one number.",
//   selectOption: "Please select a {fname}",
//   notSameAs: "{fname} and {fname2} cannot be the same.",

//   currPasswordRequired: "Current password is required!",
//   newPasswordRequired: "New password is required!",
//   confirmNewPasswordRequired: "Confirm new password is required!",
//   passwordsNotMatch: "Passwords do not match!",
//   nickNameRequired: "Nickname is required!",

//   startDateRequired: "Start date is required!",
//   endDateRequired: "End date is required!",
//   pageSizeRequired: "Page size is required!",
//   pageNumberRequired: "Page number is required!",
//   sportsTypeRequired: "Sports type is required!",

//   workingDateRequired: "Working date is required!",
//   leagueIdRequired: "League ID is required!",
//   isOutrightRequired: "Is outright is required!"

// };
